import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

interface UsersByEmailResponse {
	emails_not_found: string[];
	user_ids: string[];
}

export const useUsersByEmail = (csvEmailAddresses: string[]) => {
	const http = useHttpClient();

	return useQuery({
		queryKey: ['users-by-email', csvEmailAddresses],
		queryFn: async () => {
			const response = await http.post<UsersByEmailResponse>('/users/lookup_by_emails', {
				emails: csvEmailAddresses,
			});

			return response.data;
		},
		refetchOnWindowFocus: false,
	});
};
